"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.native.help': 'Wiedza natywna jest ukryta przed zwykłymi użytkownikami, ale dostępna dla asystentów AI',
};
